import styled, { StyledComponentProps } from 'styled-components'
import { cssMediaQueryBreakpoints } from '../config/breakpoints'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {}

export const StyledPlayFeaturedIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox='0 0 60 61' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <circle cx='30' cy='30.4923' r='30' />
            <path
                d='M37.9036 29.2878L25.4617 21.8209C24.4366 21.2106 22.9167 21.8209 22.9167 23.2927V38.2266C22.9167 39.5908 24.3306 40.4164 25.4617 39.7344L37.9036 32.2674C38.9994 31.5853 38.9994 29.9699 37.9036 29.2878Z'
                fill='white'
            />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    ${cssMediaQueryBreakpoints.small} {
        margin-right: 10px;
        height: 41px;
        min-height: 41px;
        width: 41px;
        min-width: 41px;
    }

    height: 45px;
    min-height: 45px;
    width: 45px;
    min-width: 45px;
    margin-right: 16px;
    cursor: pointer;

    fill: ${p => p.theme.playColor};
`
